import { Component, Input } from '@angular/core';

@Component({
  selector: 'currency-how-to-buy',
  templateUrl: './currency-how-to-buy.component.html',
  styleUrls: ['./currency-how-to-buy.component.scss'],
  standalone: false
})
export class CurrencyHowToBuyComponent {
  @Input() content: string;
  @Input() currencyName: string;
  @Input() fiatCode: string;
}
